import { errorAction, successfulAction } from '@shared/actions';
import { STATUS_CODE } from '@shared/constants';
import getUserTotalOrders from '@core/reducers/user/services/getUserTotalOrders';
import { GET_USER_TOTAL_ORDERS as type } from '@core/reducers/user/actionTypes';
import getUserId from '@core/reducers/user/selectors/getUserId';

const errorCode = STATUS_CODE.INTERNAL_ERROR;

const fetchUserTotalOrders = () => async (dispatch, getState, axios) => {
  const state = getState();
  const userId = getUserId(state);

  if (!userId) {
    dispatch(
      successfulAction({
        type,
        payload: { totalOrders: 0 },
      }),
    );
    return;
  }

  const { success, data, error } = await getUserTotalOrders({
    axios,
    userId,
  });

  if (success) {
    dispatch(
      successfulAction({
        type,
        payload: data,
      }),
    );
    return;
  }
  dispatch(errorAction({ type, error, errorCode, mute: true }));
};

export default fetchUserTotalOrders;
